const UPSActions = {
  SET_UPS_DATA: 'SET_UPS_DATA',
  RESET_UPS_DATA: 'RESET_UPS_DATA',
  SET_CATEGORY_DATA: 'SET_CATEGORY_DATA',
  SET_UPS_RESOLVED_FLAG: 'SET_UPS_RESOLVED_FLAG',
  SET_UPS_USER_DETAILS: 'SET_UPS_USER_DETAILS',
  SET_UPS_SERVICE_ERROR: 'SET_UPS_SERVICE_ERROR'
}
export default UPSActions
